import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { setCurrentCampus, setCurrentSemesterCode } from '../../../store/auth.slice';
import { doGetSemesters } from '../../../store/semester.slice';
import { doRemoveAuth } from '../../../store/auth.slice';
import { RootState } from '../../../store/rootReducer';
import qs from 'qs';
import { useSnackbar } from 'notistack';
import { Select } from 'antd';
import Button from '../../Button';
import { warningVariant, errorVariant } from '../../../lib/barVariant';
import { ISemester } from '../../../models/semesters.model';
import Loader from '../../Loader';
import SelectCampus from '../../SelectCampus';
import useNotification from '../../../hooks/useNotification';
import Checkbox from '../../Checkbox';
import SelectEduStep from '../../SelectEduStep';

const { Option } = Select;

interface IProps {
  tab: string;
}

const ClassSearch: FC<IProps> = ({
  tab,
}) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const location = useLocation();
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });
  const dispatch = useDispatch();
  const { infoNotification } = useNotification();
  const { currentCampus, currentSemesterCode } = useSelector((state: RootState) => state.auth);
  const { semesters, isLoading } = useSelector((state: RootState) => state.semester);

  const [eduStepCode, setEduStepCode] = useState('');
  const [keyword, setKeyword] = useState('');
  const [includeClosed, setIncludeClosed] = useState(false);

  useEffect(() => {
    getSemesters();

    const semesterCode = localStorage.getItem('semesterCode');
    if (semesterCode) {
      const _semesterCode = Number(semesterCode);
      const semester = semesters?.find(item => item.semesterCode === _semesterCode);
      if (semester) {
        dispatch(setCurrentSemesterCode(_semesterCode));
        onSearch(_semesterCode);  
      }
    }

    if (Object.keys(query).length > 0) {
      if (query.campus) {
        dispatch(setCurrentCampus(String(query.campus)));
      }
      if (query.semester) {
        localStorage.setItem('semesterCode', String(query.semester));
        dispatch(setCurrentSemesterCode(Number(query.semester)));
      }
      if (query.keyword) {
        setKeyword(String(query.keyword));
      }
    }
  }, []);

  const getSemesters = async () => {
    const res = await dispatch(doGetSemesters());

    switch (res?.status) {
      case 200:
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  const onSearch = (semesterCode?: number) => {
    if (!currentSemesterCode && !semesterCode) {
      return infoNotification(t('statistics.dttt.message1'));
    }

    const param: any = {
      ...query,
      page: 1,
      tab,
      campus: currentCampus,
      semester: currentSemesterCode || semesterCode,
    };

    if (eduStepCode) {
      param.eduStepCode = eduStepCode;
    } else {
      delete param.eduStepCode;      
    }
    if (keyword) {
      param.keyword = keyword;
    } else {
      delete param.keyword;
    }
    if (includeClosed) {
      param.includeClosed = true;
    } else {
      delete param.includeClosed;
    }

    history.push(`/class/class?${qs.stringify(param)}`);
  }

  return (
    <>
      {isLoading && <Loader />}
      <div className="card card-info">
        <div className="card-body">
          <div className="flex flex-justify-center">
            <div>
              <div className="flex flex-justify-center">
                <div className="w-150p mr-1">
                  <SelectCampus />
                </div>
                <div className="w-150p mr-1">
                  <Select
                    className="w-100"
                    placeholder={t('class.class.placeholder4')}
                    value={currentSemesterCode}
                    onChange={value => {
                      dispatch(setCurrentSemesterCode(value));
                    }}
                  >
                    {
                      semesters?.map((item: ISemester) => {
                        return (
                          <Option
                            key={item.semesterCode}
                            value={item.semesterCode || ''}
                          >
                            {item.semesterName}
                          </Option>
                        )
                      })
                    }
                  </Select>
                </div>
              </div>
              <div className="flex flex-justify-center mt-1">
                <input
                  type="text"
                  className="form-control w-300p mr-1"
                  placeholder={t('class.class.placeholder3')}
                  value={keyword}
                  onChange={e => setKeyword(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') onSearch();
                  }}
                />
              </div>
              <div className="mt-2 ml-2">
                <Checkbox
                  checked={includeClosed}
                  onChange={() => setIncludeClosed(!includeClosed)}
                  text={t('class.class.option1')}
                />
              </div>
            </div>
            <Button
              className='btn btn-secondary btn-wh62p'
              onClick={() => onSearch()}
              text={t('common.button.search')}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default ClassSearch;
